// 第1张
const imgAllA = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724578776517/dd3.png',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015852850/r3_eu.png',
        h5: '',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015937853/r3_uk.png',
        h5: '',
    },
    AU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1736826721713/12_1.png',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751253770114/r3p-1.png',
    },
};
export const imgLocaleA: any = {
    us: imgAllA.NA,
    ca: imgAllA.NA,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
    au: imgAllA.AU,
    ph: imgAllA.PH,
};

// 第2张
const imgAllB = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724578776333/dd2.png',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015884744/r3_plus_eu.png',
        h5: '',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015958676/r3_plus_uk.png',
        h5: '',
    },
    AU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1736826722085/12_2.png',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751253770712/r3m-1.png',
    },
};
export const imgLocaleB: any = {
    us: imgAllB.NA,
    ca: imgAllB.NA,
    uk: imgAllB.UK,
    eu: imgAllB.EU,
    de: imgAllB.EU,
    fr: imgAllB.EU,
    it: imgAllB.EU,
    es: imgAllB.EU,
    au: imgAllB.AU,
    ph: imgAllB.PH,
};

// 第3张
const imgAllC = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724578027910/sl_r3m.png',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015903418/r3_max_eu.png',
        h5: '',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015976839/r3_max_uk.png',
        h5: '',
    },
    AU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1736826722249/12_3.png',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751253770321/r3mp-1.png',
    },
};
export const imgLocaleC: any = {
    us: imgAllC.NA,
    ca: imgAllC.NA,
    uk: imgAllC.UK,
    eu: imgAllC.EU,
    de: imgAllC.EU,
    fr: imgAllC.EU,
    it: imgAllC.EU,
    es: imgAllC.EU,
    au: imgAllC.AU,
    ph: imgAllC.PH,
};
